import { IAddress } from '~/types'

export const buildSendPath = (address: IAddress) => {
  const params = new URLSearchParams()
  params.set('recipients', JSON.stringify([{ address }]))
  return `/send?${params.toString()}`
}
